module.exports = __webpack_public_path__ + "img/icon-stockpicker-loading@3x.7f940a81.png";